/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreportreasoninappropriate3Inputs */

const en_contentreportreasoninappropriate3 = /** @type {(inputs: Contentreportreasoninappropriate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inappropriate content`)
};

const de_contentreportreasoninappropriate3 = /** @type {(inputs: Contentreportreasoninappropriate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unangemessener Inhalt`)
};

/**
* | output |
* | --- |
* | "Inappropriate content" |
*
* @param {Contentreportreasoninappropriate3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreportreasoninappropriate3 = /** @type {((inputs?: Contentreportreasoninappropriate3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreportreasoninappropriate3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreportreasoninappropriate3(inputs)
	return de_contentreportreasoninappropriate3(inputs)
});
export { contentreportreasoninappropriate3 as "contentReportReasonInappropriate" }